export default {
	colors: {
		primary: '#A90AF2',
	},
	primary: '#A90AF2',
	shadow: '#222',
	component: '#555',
};
